import { render } from "./analysisAnswer.vue?vue&type=template&id=686820d8&scoped=true&ts=true&lang=pug"
import script from "./analysisAnswer.vue?vue&type=script&lang=ts"
export * from "./analysisAnswer.vue?vue&type=script&lang=ts"

import "./analysisAnswer.vue?vue&type=style&index=0&id=686820d8&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686820d8"]])

export default __exports__